import getClient from "./getClient";

export default function verifyOtp({ code, email }) {
  return getClient().auth.verifyOtp({
    email,
    token: code,
    type: "email",
  });
}
